import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import {
    Avatar,
    Box,
    ButtonBase,
    CardContent,
    ClickAwayListener,
    Grid,
    IconButton,
    Paper,
    Popper,
    Stack,
    Tab,
    Tabs,
    Typography
} from '@mui/material';

// project import
import MainCard from '../../../../../components/MainCard';
import Transitions from '../../../../../components/@extended/Transitions';
import ProfileTab from './ProfileTab';
import SettingTab from './SettingTab';

// assets

import { LogoutOutlined, SettingOutlined, UserOutlined } from '@ant-design/icons';
import { Cookies } from 'react-cookie';
import { openredirect } from '../../../../../store/redirect';
import { useDispatch } from 'react-redux';

// tab panel wrapper
type TabPanelProps = {
    children: React.ReactNode;
    index: any;
    value: any;
    dir: any;
}

function TabPanel({ children, value, index, dir }: TabPanelProps) {
    return (
        <div role="tabpanel" hidden={value !== index} id={`profile-tabpanel-${index}`} aria-labelledby={`profile-tab-${index}`}>
            {value === index && children}
        </div>
    );
}


function a11yProps(index: any) {
    return {
        id: `profile-tab-${index}`,
        'aria-controls': `profile-tabpanel-${index}`
    };
}

// ==============================|| HEADER CONTENT - PROFILE ||============================== //

const Profile = () => {
    const theme = useTheme();
    const dispatch = useDispatch();

    const handleLogout = () => {
        new Cookies().remove('token',{path:'/'});
        new Cookies().remove('image', { path: '/' });
        new Cookies().remove('name', { path: '/' });

        dispatch(openredirect({isAuth:false}))
        window.location.href = '/login';


    };

    const anchorRef = useRef<any>(null);
    const [open, setOpen] = useState(false);
    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event: MouseEvent | TouchEvent) => {
        if (anchorRef.current!=null) {
            if (anchorRef.current.contains(event.target)) {
                return;
            }
        }
        setOpen(false);
    };

    const [value, setValue] = useState(0);

    const handleChange = (event:React.SyntheticEvent, newValue: any) => {
        setValue(newValue);
    };

    const iconBackColorOpen = 'grey.300';

    const name = new Cookies().get('user');

    const img= new Cookies().get('image')

    return (
        <Box sx={{ flexShrink: 0, ml: 0.75 }}>

            <ButtonBase
                sx={{
                    p: 0.25,
                    color: open ? 'primary.main' : 'grey.600',
                    bgcolor: open ? iconBackColorOpen : 'transparent',
                    borderRadius: 1,
                    '&:hover': { bgcolor: 'primary.main', color: '#fff' },
                }}
                aria-label="open profile"
                ref={anchorRef}
                aria-controls={open ? 'profile-grow' : undefined}
                aria-haspopup="true"
                onClick={handleToggle}
            >



                <Stack direction="row" spacing={2} alignItems="center" sx={{ p: 0.5 }}>
                    <Avatar  variant="square" alt="profile user" src={`https://jeziorakyachtclub.octupus.pl/api/media/serve/${img._id}?w=300&h=300&ext=webp`} sx={{ width: 32, height: 32 }} />
                    <Typography variant="subtitle1">{name}</Typography>
                </Stack>
            </ButtonBase>
            <Popper
                placement="bottom-end"
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                transition
                disablePortal
                popperOptions={{
                    modifiers: [
                        {
                            name: 'offset',
                            options: {
                                offset: [0, 9]
                            }
                        }
                    ]
                }}
            >
                {({ TransitionProps }) => (
                    <Transitions type="fade" in={open} {...TransitionProps}>
                        {open && (
                            <Paper
                                sx={{
                                    boxShadow: '2px 2px 2px 1px rgba(0, 0, 0, 0.03)',
                                    width: 290,
                                    minWidth: 240,
                                    maxWidth: 290,
                                    [theme.breakpoints.down('md')]: {
                                        maxWidth: 250
                                    }
                                }}
                            >
                                <ClickAwayListener onClickAway={(event) => { handleClose(event) }}>
                                    <MainCard elevation={0} border={false} content={false}>
                                        <CardContent sx={{ px: 2.5, pt: 3 }}>
                                            <Grid container justifyContent="space-between" alignItems="center">
                                                <Grid item>
                                                    <Stack direction="row" spacing={1.25} alignItems="center">
                                                        <Avatar  variant="square" alt="profile user" src={`https://jeziorakyachtclub.octupus.pl/api/media/serve/${img._id}?w=300&h=300&ext=webp`} sx={{ width: 32, height: 32 }} />
                                                        <Stack>
                                                            <Typography variant="h6">{name}</Typography>
                                                            <Typography variant="body2" color="textSecondary">

                                                            </Typography>
                                                        </Stack>
                                                    </Stack>
                                                </Grid>
                                                <Grid item>
                                                    <IconButton size="large" color="secondary" onClick={handleLogout}>
                                                        <LogoutOutlined />
                                                    </IconButton>
                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                        {open && (
                                            <>
                                                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                                    <Tabs
                                                        variant="fullWidth"
                                                        value={value}
                                                        onChange={handleChange}
                                                        aria-label="profile tabs"
                                                    >
                                                        <Tab
                                                            sx={{
                                                                display: 'flex',
                                                                flexDirection: 'row',
                                                                justifyContent: 'center',
                                                                alignItems: 'center',
                                                                textTransform: 'capitalize'
                                                            }}
                                                            icon={<UserOutlined style={{ marginBottom: 0, marginRight: '10px' }} />}
                                                            label="Profil"
                                                            {...a11yProps(0)}
                                                        />
                                                        {/* <Tab
                                                            sx={{
                                                                display: 'flex',
                                                                flexDirection: 'row',
                                                                justifyContent: 'center',
                                                                alignItems: 'center',
                                                                textTransform: 'capitalize'
                                                            }}
                                                            icon={<SettingOutlined style={{ marginBottom: 0, marginRight: '10px' }} />}
                                                            label="Setting"
                                                            {...a11yProps(1)}
                                                        /> */}
                                                    </Tabs>
                                                </Box>
                                                <TabPanel value={value} index={0} dir={theme.direction}>
                                                    <ProfileTab handleLogout={handleLogout} />
                                                </TabPanel>
                                                <TabPanel value={value} index={1} dir={theme.direction}>
                                                    <SettingTab />
                                                </TabPanel>
                                            </>
                                        )}
                                    </MainCard>
                                </ClickAwayListener>
                            </Paper>
                        )}
                    </Transitions>
                )}
            </Popper>
        </Box>
    );
};

export default Profile;
